module.exports = __webpack_public_path__ + "assets/pink-facebook.a87299a9.svg";